import clone from 'clone';

/**
 * mutates the permissions.rnc property with the data given, as-is
 */
export const getRescueNetCompanyPermissions = (state, data) => {
  state.permissions.rnc = clone(data);
};
